export const titleFormatOptions = [
  { value: 'title', label: 'Title' },
  { value: 'brand', label: 'Brand' },
  { value: 'vendor', label: 'Vendor' },
  { value: 'productType', label: 'Product type' },
]

export const titleSeparatorOptions = [
  { value: '-', label: 'Hyphen "-"' },
  { value: '|', label: 'Pipe "|"' },
  { value: '–', label: 'En dash "–"' },
  { value: '—', label: 'Em dash "—"' },
]
